export default __webpack_public_path__ + "static/media/1426.99b5ddce.png";